import { useEffect, useState } from 'react';
import { setGlobalTheme, themeObjectToString, type ThemeState } from '@atlaskit/tokens';

export const useTheme = () => {
  // Dark mode is not supported yet as it look bad. Seems like it was intended to support it but never finished.
  // Forcing light mode for now.
  // const [theme] = useState<Partial<ThemeState>>(getThemePreference());
  const [theme] = useState<Partial<ThemeState>>({ colorMode: 'light', typography: 'typography-adg3' });

  useEffect(() => {
    setGlobalTheme(theme);
    window.localStorage.setItem('theme', themeObjectToString(theme));
  }, [theme]);
};

// const getThemePreference = (): Partial<ThemeState> => {
//   if (typeof window == 'undefined') {
//     return { colorMode: 'light' };
//   }
//   const savedThemePreference = window.localStorage.getItem('theme');
//   // legacy saved theme
//   if (savedThemePreference === 'light' || savedThemePreference === 'dark') {
//     return { colorMode: savedThemePreference };
//   } else if (savedThemePreference !== null) {
//     return themeStringToObject(savedThemePreference);
//   }
//   return getOsThemePreference();
// };

// const getOsThemePreference = (): Partial<ThemeState> => {
//   const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
//   if (darkModeMediaQuery.matches) {
//     return { colorMode: 'dark' };
//   }
//   return { colorMode: 'light' };
// };
